var _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetbanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5617",
    "data-name": "Group 5617",
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.799,
    height: 24.078,
    viewBox: "0 0 81.799 24.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "internet-banking"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    "data-name": "Path 3119",
    d: "M22.473,0H1.605A1.605,1.605,0,0,0,0,1.605V22.473a1.605,1.605,0,0,0,1.605,1.605H22.473a1.605,1.605,0,0,0,1.605-1.605V1.605A1.605,1.605,0,0,0,22.473,0ZM1.605.8H22.473a.8.8,0,0,1,.8.8V3.21H.8V1.605a.8.8,0,0,1,.8-.8ZM22.473,23.276H1.605a.8.8,0,0,1-.8-.8V4.013H23.276v18.46A.8.8,0,0,1,22.473,23.276Z",
    transform: "translate(0 0)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3120",
    "data-name": "Path 3120",
    d: "M48.809,44.717V44.2a1.2,1.2,0,0,0-2.408,0v.513a.8.8,0,0,0-.4.691v1.605a.8.8,0,0,0,.8.8h1.605a.8.8,0,0,0,.8-.8V45.408A.8.8,0,0,0,48.809,44.717ZM47.2,44.2a.4.4,0,0,1,.8,0v.4h-.8Zm-.4,2.809V45.408h1.605v1.605Z",
    transform: "translate(-27.54 -25.744)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    "data-name": "Path 3121",
    d: "M20.046,45H6.8a.8.8,0,0,0-.8.8V48.21a.8.8,0,0,0,.8.8H20.046a.8.8,0,0,0,.8-.8V45.8A.8.8,0,0,0,20.046,45ZM6.8,48.21V45.8H20.046V48.21Z",
    transform: "translate(-3.592 -26.941)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3122",
    "data-name": "Path 3122",
    d: "M4.4,4.8h.4a.4.4,0,1,0,0-.8H4.4a.4.4,0,1,0,0,.8Z",
    transform: "translate(-2.395 -2.395)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3123",
    "data-name": "Path 3123",
    d: "M9.4,4.8h.4a.4.4,0,1,0,0-.8H9.4a.4.4,0,1,0,0,.8Z",
    transform: "translate(-5.388 -2.395)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3124",
    "data-name": "Path 3124",
    d: "M14.4,4.8h.4a.4.4,0,1,0,0-.8h-.4a.4.4,0,1,0,0,.8Z",
    transform: "translate(-8.382 -2.395)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3125",
    "data-name": "Path 3125",
    d: "M11.8,49h-.4a.4.4,0,1,0,0,.8h.4a.4.4,0,1,0,0-.8Z",
    transform: "translate(-6.586 -29.336)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3126",
    "data-name": "Path 3126",
    d: "M17.8,49h-.4a.4.4,0,1,0,0,.8h.4a.4.4,0,0,0,0-.8Z",
    transform: "translate(-10.178 -29.336)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3127",
    "data-name": "Path 3127",
    d: "M23.8,49h-.4a.4.4,0,0,0,0,.8h.4a.4.4,0,0,0,0-.8Z",
    transform: "translate(-13.77 -29.336)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3128",
    "data-name": "Path 3128",
    d: "M29.8,49h-.4a.4.4,0,1,0,0,.8h.4a.4.4,0,1,0,0-.8Z",
    transform: "translate(-17.362 -29.336)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3129",
    "data-name": "Path 3129",
    d: "M35.8,49h-.4a.4.4,0,1,0,0,.8h.4a.4.4,0,1,0,0-.8Z",
    transform: "translate(-20.954 -29.336)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3130",
    "data-name": "Path 3130",
    d: "M48.4,4.8h2.408a.4.4,0,1,0,0-.8H48.4a.4.4,0,1,0,0,.8Z",
    transform: "translate(-28.737 -2.395)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3131",
    "data-name": "Path 3131",
    d: "M26.44,23.238h-.4v-.4a1.2,1.2,0,0,0-.8-1.13v-3.8a.8.8,0,0,0,.4-.691v-.8h.08a.722.722,0,0,0,.354-1.352l-5.3-2.97a.73.73,0,0,0-.708,0h0l-5.3,2.97a.722.722,0,0,0,.354,1.352h.08v.8a.8.8,0,0,0,.4.691v3.8a1.2,1.2,0,0,0-.8,1.13v.4h-.4a.4.4,0,1,0,0,.8H26.44a.4.4,0,1,0,0-.8Zm-9.23-5.217v3.612h-.8V18.021Zm.8,0h1.2v3.612h-1.2Zm2.007,0h.8v3.612h-.8Zm1.605,0h1.2v3.612h-1.2Zm2.007,0h.8v3.612h-.8Zm-3.21-5.206,4.989,2.8H15.432Zm4.414,3.6v.8H16.007v-.8Zm-9.23,6.421a.4.4,0,0,1,.4-.4h8.829a.4.4,0,0,1,.4.4v.4H15.605Z",
    transform: "translate(-8.382 -7.186)",
    fill: "#474747"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "NetBanking",
    transform: "translate(28.799 15.039)",
    fill: "#474747",
    fontSize: 9,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NetBanking"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetbanking);
export default __webpack_public_path__ + "static/media/netbanking.08321c45238c49a4fcff6ce7d0e1fb29.svg";
export { ForwardRef as ReactComponent };